module.exports = __webpack_public_path__ + "img/360-produktion-svarv-old.bbde2887.jpg";